// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2wllj","detailsBorder":"styles_detailsBorder__1GOW_"};